import { AlertTriangle, MessageCircle, Rocket } from "lucide-react";

const INSIGHTS = [
  {
    testId: "insight-500",
    Icon: AlertTriangle,
    accent: "#EF4444",
    stat: "500 MQLs → 10 SQLs",
    body:
      "The unmanaged industry average. Every un-nurtured lead costs $162–$286 in acquisition spend.",
    source: "InfluxMD 2026",
  },
  {
    testId: "insight-sms",
    Icon: MessageCircle,
    accent: "#0EA5E9",
    stat: "98% SMS Open Rate",
    body:
      "The highest-leverage channel in medical device follow-up. Most companies never use it.",
    source: "Blueprint Insight 4",
  },
  {
    testId: "insight-21",
    Icon: Rocket,
    accent: "#00C2A8",
    stat: "21% Conversion Rate",
    body:
      "What top-performing manufacturers achieve with proper automated nurture. 7x the industry average.",
    source: "InfluxMD 2026",
  },
];

export default function WhyThisExists() {
  return (
    <section data-testid="why-this-exists" className="space-y-4">
      <div className="flex items-center gap-3">
        <div
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: 10,
            letterSpacing: "0.14em",
            color: "var(--text-muted)",
            textTransform: "uppercase",
          }}
        >
          Why this exists
        </div>
        <div style={{ flex: 1, height: 1, background: "var(--border-divider)" }} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {INSIGHTS.map((it, i) => {
          const { Icon } = it;
          return (
            <article
              key={it.testId}
              data-testid={it.testId}
              className="card-glass card-interactive p-6 enter-up"
              style={{ animationDelay: `${i * 90}ms` }}
            >
              <div className="flex items-center gap-2.5 mb-4">
                <div
                  className="flex items-center justify-center rounded-md"
                  style={{
                    width: 28,
                    height: 28,
                    background: `${it.accent}12`,
                    border: `1px solid ${it.accent}30`,
                  }}
                >
                  <Icon size={14} color={it.accent} />
                </div>
                <span
                  style={{
                    fontFamily: "'JetBrains Mono', monospace",
                    fontSize: 10,
                    letterSpacing: "0.12em",
                    color: "var(--text-muted)",
                    textTransform: "uppercase",
                  }}
                >
                  Insight · #{i + 1}
                </span>
              </div>

              <h3
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 700,
                  fontSize: 22,
                  letterSpacing: "-0.02em",
                  color: it.accent,
                  marginBottom: 12,
                }}
              >
                {it.stat}
              </h3>

              <p
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: 13,
                  lineHeight: 1.55,
                  color: "var(--text-secondary)",
                  marginBottom: 18,
                }}
              >
                {it.body}
              </p>

              <div
                className="pt-3"
                style={{
                  borderTop: "1px solid var(--border-divider)",
                  fontFamily: "'JetBrains Mono', monospace",
                  fontSize: 10,
                  letterSpacing: "0.08em",
                  color: "var(--text-muted)",
                  textTransform: "uppercase",
                }}
              >
                Source: {it.source}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
